
document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;

  // スラッシュのみ（つまりトップページ）かどうかを判定
  if (path === '/' || path === '/index.html' || path.includes('/fr/') || path.includes('/en/')) {
    const swiper = new Swiper('.swiper', {
      loop: true,
      effect: 'fade',
      speed: 2000,
      autoplay: {
        delay: 3000,
      },
    });
  }

  // 商品ページ
  if (path.includes('/products/')) {
    // サムネイル
    const sliderThumbnail = new Swiper(".slider-thumbnail", {
      slidesPerView: 3, // サムネイルの枚数
    });
    // スライダー
    const slider = new Swiper(".slider", {
      loop: true, // ループ
      speed: 1000, // 少しゆっくり(デフォルトは300)
      thumbs: {
        swiper: sliderThumbnail,
      },
    });
  }
  
  // Kimono Experience & Photo
  if (path.includes('/experience/') || path.includes('/fr-experience/') || path.includes('/en-experience/')) {
    const swiper = new Swiper('.mainSwiper', {
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      observer: true,
      observeParents: true,
      spaceBetween: 0,
      speed: 1500,
      autoplay: {
        delay: 3000,
      },
      breakpoints: {
        480: {
            slidesPerView: 2, // 480px以上では2枚表示
            spaceBetween: 10, // 480px以上ではスライド間の余白を20pxに
        },
      }
    });
  }

  // RESERVATION
  if (path.includes('/reservation/')) {
    document.getElementById('ContactFormType').addEventListener('change', function () {
      const selectedValue = this.value;
      if (selectedValue === 'KYOTO Kimono Photo') {
        window.location.href = '/pages/appointment/'; // ←ここにリンク先のURLを入力
      }
    });
  }
  if (path.includes('/fr-reservation/')) {
    document.getElementById('ContactFormType').addEventListener('change', function () {
      const selectedValue = this.value;
      if (selectedValue === 'KYOTO Kimono Photo') {
        window.location.href = '/pages/fr-appointment/'; // ←ここにリンク先のURLを入力
      }
    });
  }
  if (path.includes('/en-reservation/')) {
    document.getElementById('ContactFormType').addEventListener('change', function () {
      const selectedValue = this.value;
      if (selectedValue === 'KYOTO Kimono Photo') {
        window.location.href = '/pages/en-appointment/'; // ←ここにリンク先のURLを入力
      }
    });
  }

  // カート
  if (path.includes('/cart')) {
    const checkbox = document.getElementById('cart-checkbox');
    const submitBtn = document.getElementById('checkout-button');

    if (!checkbox || !submitBtn) return;

    // 初期状態：未チェックなら送信不可
    submitBtn.disabled = !checkbox.checked;

    // チェック状態に応じて有効/無効を切り替え
    checkbox.addEventListener('change', function () {
      submitBtn.disabled = !checkbox.checked;
    });

    // 念のため：未チェックで押された場合は送信させない
    submitBtn.addEventListener('click', function (e) {
      if (!checkbox.checked) {
        e.preventDefault();
        checkbox.focus();
        // 必要ならアラート
        // alert('内容をご確認のうえ、チェックを入れてからお進みください。');
      }
    });
  }

  // フランスページ
  if (path === '/pages/akane-france/' || path.includes('/fr-akane-france/') || path.includes('/en-akane-france/')) {
    window.addEventListener('load', function () {
      const swiper01 = new Swiper('.mainSwiper', {
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
        speed: 1500,
        autoplay: {
          delay: 3000,
        },
        breakpoints: {
          480: {
              slidesPerView: 2, // 480px以上では2枚表示
              spaceBetween: 10, // 480px以上ではスライド間の余白を20pxに
          },
        }
      });

      const swiper02 = new Swiper('.serviceSwiper', {
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        speed: 1000,
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });

    });
    
  }

  const links = document.querySelectorAll('a[href^="#"]');
  const header = document.querySelector('header');
  let headerHeight = header.offsetHeight;

  links.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href");
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const top = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;

        window.scrollTo({
          top: top,
          behavior: "smooth"
        });
      }
    });
  });

  if (!header) return;
  function onScroll() {
    if (window.scrollY >= headerHeight) {
      header.classList.add('active');
    } else {
      header.classList.remove('active');
    }
  }
  // 初回スクロールイベント登録
  window.addEventListener('scroll', onScroll);
  // リサイズ時にheaderHeightを再取得
  window.addEventListener('resize', function () {
    headerHeight = header.offsetHeight;
    onScroll(); // リサイズ後すぐに状態を更新
  });

  const hamburger = document.querySelector('.hamburgerBtn');
  const menu = document.querySelector('.header__right');
  const title = document.querySelector('.header__title');
  if (!hamburger) return;
  if (!hamburger || !menu) return;
  hamburger.addEventListener('click', function () {
    this.classList.toggle('active');
  });
  hamburger.addEventListener('click', function () {
    header.classList.toggle('is-visible');
    menu.classList.toggle('is-visible');
    title.classList.toggle('is-visible');
  });
  window.addEventListener('resize', function () {
    hamburger.classList.remove('active');
    header.classList.remove('is-visible');
    menu.classList.remove('is-visible');
    title.classList.remove('is-visible');
  });

  const trigger = document.querySelector(".header__right ul li p");
  const menuList = trigger.nextElementSibling;
  if (trigger && menuList) {
    trigger.addEventListener("mouseenter", () => {
      menuList.classList.add("active");
    });

    trigger.addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (!menuList.matches(':hover')) {
          menuList.classList.remove("active");
        }
      }, 200);
    });

    menuList.addEventListener("mouseleave", () => {
      menuList.classList.remove("active");
    });

    menuList.addEventListener("mouseenter", () => {
      menuList.classList.add("active");
    });
  }

  const lang = document.querySelector(".header__right .lang");
  const langList = document.querySelector(".header__right .langList");
  if (lang && langList) {
    lang.addEventListener("mouseenter", () => {
      langList.classList.add("active");
    });

    lang.addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (!langList.matches(':hover')) {
          langList.classList.remove("active");
        }
      }, 200);
    });

    langList.addEventListener("mouseleave", () => {
      langList.classList.remove("active");
    });

    langList.addEventListener("mouseenter", () => {
      langList.classList.add("active");
    });
  }

  const currentURL = window.location.pathname;
  const langL = document.querySelector(".header__right .lang");
  if (currentURL.includes('/en')) {
    document.querySelector('.langList .en').classList.add('active');
  } else if (currentURL.includes('/fr')) {
    document.querySelector('.langList .fr').classList.add('active');
  } else {
    document.querySelector('.langList .jp').classList.add('active');
  }

});